import { CoreAuthService } from 'platform-core/ui'
import { submitRequest } from '@/util'

export class AuthService extends CoreAuthService {
  constructor () {
    super(submitRequest)
  }
}
